module.exports = __webpack_public_path__ + "static/media/icono-rinde-mas-compradores-uy.3ef39c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-rinde-mas-compradores-uy.png
// module id = 323
// module chunks = 0